<template>
    <div id="masthead-wrapper" class="masthead-wrapper">
        <div id="masthead" class="masthead">
            <div class="masthead-inner col-sm-12 col-md-4 col-lg-2">
                <button id="menu-button" class="menu-button" title="Show Menu">
                    <span class="hamburger">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                    <span class="close">
                        <span></span>
                        <span></span>
                    </span>
                </button>

                <!--Note: normally I'd use a script that inlines the SVG but Codepen security won't let me do that. Using SVG sprite for this demo-->
                <a href="/"><img v-bind:src="'/img/brand/' + brand" alt="Logo" width="175" /></a>
                <!--<svg class="masthead-logo">
                    <use xlink:href="#symbol-logo"></use>
                </svg>-->
                <!--<svg class="utility-icon search-mobile">
                    <use xlink:href="#symbol-search"></use>
                </svg>-->
                <span v-if="this.dealerLocation?.address && (!this.isNational)" class="header-location">{{ this.dealerLocation?.address?.city }}</span>
            </div>
            <div class="utility-nav col-sm-12 col-md-4 col-lg-3">

                <ul>
                    <li v-for="(item, index) in utility" :key="item.name" :id="'nav-header-item-' + index" style="display: inline-block">
                        <a v-if="!isNational || item.showForNational === true"
                           :href="item.link"
                           role="button"
                           :class="item.class"
                           :target='item.target'
                           aria-haspopup="true"
                           aria-expanded="false"
                           :data-idx='index'
                           :data-preventDef="item.dropdown">
                            {{ item.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    <nav class="navigation">
        <ul class="nav-list">
            <li v-for="(item, index) in data" :key="item.name" :id="'nav-list-item-' + index" class="nav-list-item">
                <a v-if="!isNational || item.showForNational === true"
                   :href="item.link"
                   role="button"
                   :target='item.target'
                   aria-haspopup="true"
                   aria-expanded="false"
                   :class="item.smallMenu === false ? 'nav-link' : 'nav-link header'"
                   :data-idx='index'
                   :data-preventDef="item.dropdown">
                    {{ item.name }}
                    <svg v-if="item.dropdown === true" class="nav-icon-chevron" viewBox="0 0 20 20" fill="none">
                        <path d="M5.61401 2.08333L13.9473 10.4167L5.61401 18.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </a>
                <span v-if="item.dropdown === true" class="secondary-list-container">
                    <ul class="nav-list-secondary">
                        <li class="back-item"><button class="back-button" id="back-button">Back</button></li>
                        <li v-for="lnk in item.dropdownLinks" :key="lnk.name">
                            <a :href="lnk.link"
                               :target="lnk.target">
                                {{ lnk.name }}
                                <svg v-if="lnk.dropdown === true" class="nav-icon-chevron" viewBox="0 0 20 20" fill="none">
                                    <path d="M5.61401 2.08333L13.9473 10.4167L5.61401 18.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </span>

            </li>

        </ul>
    </nav>
    <div class="overlay" id="overlay"></div>
    </div>
</template>

<script>

    export default { 
        name: "SiteHeaderMc", 
          props: ["brand", "data", "utility"],
        components: {
        },
        data: function() {
            return {
                menuButton: {},
                body: {},
                overlay: {},
                boatsLink: [],
                backButtons: [],
                subNavLinks: [],
                // navActive toggles display of nav / not visible to users
                navActive: false,
                // showNav toggles the animation of the navigation
                showNav: false,
                // boatsActive toggles the animation of the navigation at desktop
                // boatsActive: false,
                subNavActive: false,
                subNavIdx: 0,
                dealerLocation: window.DEALER_LOCATION,
                isNational: false
            }
        },

        mounted() {
            this.menuButton = document.getElementById("menu-button");
            this.body = document.getElementById("body");
            this.overlay = document.getElementById("overlay");
            this.boatsLink = document.getElementById("boats-link");
            this.backButtons = document.querySelectorAll(".back-button");
            this.subNavLinks = document.querySelectorAll(".nav-link");

            this.addEventListners();
            this.isNational = window.IS_NATIONAL;

            
            //console.log(this.dealerLocation);

        },
        methods: {
        // shared function that closes all the navigation and subnav and resets the boats active state for desktop
            closeNav: function () {

                if (this.subNavActive) {
                    document
                        .getElementById("nav-list-item-" + this.subNavIdx)
                        .classList.remove("active");
                    this.subNavActive = false;
                    this.subNavIdx = 0;
                }

                this.body.classList.remove("show-nav");
                this.showNav = false;

                // setTimeout to remove the nav-active class which toggles the display of the nav. navigation alse to display none once nav has collapsed.
                setTimeout(() => {
                    this.body.classList.remove("nav-active");
                    this.navActive = false;
                }, 900);
            },


            addEventListners: function () {
                var self = this;
                if (this.menuButton != null) {
                    this.menuButton.addEventListener("click", () => {
                        if (!this.navActive) {

                            // Sets nav the nav to display block in the DOM,
                            this.body.classList.add("nav-active");

                            //the use timeout to add the `show-nav` class to reveal the nav and trigger the animation.
                            setTimeout(() => {
                                this.body.classList.add("show-nav");
                                this.showNav = true;
                                this.navActive = true;

                                // when opening the navigation we default to boats open at desktop
                                //document.getElementById("nav-list-item-0").classList.add("boats-active");
                                //this.boatsActive = true;
                            }, 10);
                        } else {
                            this.closeNav();
                        }
                    });
                }

                // event handlers for all the subnav links.
                if (this.subNavLinks != null) {
                    this.subNavLinks.forEach(function (element) {
                        element.addEventListener("click", function (e) {
                            if (this.dataset.preventDef === true) {
                                e.preventDefault();
                            }

                            if (self.subNavActive) {
                                document
                                    .getElementById("nav-list-item-" + self.subNavIdx)
                                    .classList.remove("active");
                                console.log("Removed active from " + self.subNavIdx);
                            }
                            var idx = this.dataset.idx;
                            document.getElementById("nav-list-item-" + idx).classList.add("active");
                            self.subNavActive = true;
                            self.subNavIdx = idx;
                        });
                    });
                }


                //event handlers for all the back buttons in the subnav, which are only visible at mobile
                if (this.backButtons != null) {
                    this.backButtons.forEach(function (element) {
                        element.addEventListener("click", function (e) {
                            if (this.subNavActive) {
                                document
                                    .getElementById("nav-list-item-" + this.subNavIdx)
                                    .classList.remove("active");
                                this.subNavActive = false;
                            }
                            e.preventDefault();
                        });
                    });
                }

                // always close menus and modals when the escape key is clicked
                if (this.body != null) {
                    this.body.addEventListener("keydown", function (event) {
                        if (event.keyCode === 27) {
                            this.closeNav();
                        }
                    });
                }

                // always close menus and modals when the overlay or background is clicked
                if (this.overlay != null) {
                    this.overlay.addEventListener("click", () => {
                        this.closeNav();
                    });
                }
                console.log("Added event listeners");
            }

        }
    };

</script>

